module.exports = __webpack_public_path__ + "img/icon_kechenglinagdian.c2cf892c.svg";